import { PoNotificationService } from '@po-ui/ng-components';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PoComboOption, PoModalAction, PoModalComponent, PoSelectOption } from '@po-ui/ng-components';
import { LoginService } from "../login/login.service";
import { HomeService } from "./home.service";
import { firstValueFrom } from 'rxjs';
import { ImportacaoService } from '../orcamento/orcamento-form/importacao';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css'],
	standalone: false,
})
export class HomeComponent implements OnInit {

	@ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
	@ViewChild("modalVideo", { static: false }) modalVideo: PoModalComponent;
	@ViewChild("aviso", { static: false }) modalAviso: PoModalComponent;


	nome = sessionStorage.getItem("userName");
	tpUser = sessionStorage.getItem("tipoUser");
	seguimento = "";
	SelectEmpOpcao: Array<any> = new Array();
	selectDisable: boolean = true;
	EmpOpcao: Array<PoComboOption>;
	EmpSegmento: string;
	Portal: string;
	isHideLoading: boolean;
	options: Array<PoSelectOption>;
	videos;


	constructor(
		private loginService: LoginService,
		private homeService: HomeService,
		private poNotification: PoNotificationService,
		public importacaoService: ImportacaoService
	) { }

	async ngOnInit() {
		if (this.tpUser === 'U') {
			this.openEmpresas();
		}

		this.EmpSegmento = '';
		this.seguimento = sessionStorage.getItem("Segmento");
		this.isHideLoading = true;

		this.importacaoService.impOff()

		await this.carregarSegmentos();

		this.modalAviso.open();
		this.selectDisable = false
	}

	private async carregarSegmentos(): Promise<void> {
		try {
			const data = await firstValueFrom(this.homeService.getSegmentos());
			this.options = [];
			const segmentos: string[] = data.descricao.split(";");

			segmentos.forEach((segmento) => {
				this.options.push({ label: segmento, value: segmento.toUpperCase() });
			});
		} catch (error) {
			console.error("Erro ao carregar segmentos:", error);
		}
	}

	close: PoModalAction = {
		action: () => {
			this.loginService.fazerLogout();
			this.closeModal();
		},
		label: 'Sair',
		danger: true
	};

	confirm: PoModalAction = {
		action: () => {

			if (this.isOk()) {
				this.poModal.close();
			}
		},
		label: 'Selecionar',

	};

	closeModal() {
		this.poModal.close();
	}

	openEmpresas() {
		this.poModal.open();
	}

	async listaClientes() {
		this.EmpSegmento = null;
		this.EmpOpcao = await this.seguimentos();
	}

	async seguimentos(): Promise<PoComboOption[]> {
		this.SelectEmpOpcao = [];

		try {
			const seguimentos = await firstValueFrom(
				this.homeService.getSeguimentos(sessionStorage.getItem("codeuser"), this.Portal)
			);

			this.SelectEmpOpcao = seguimentos.map(seguimento => ({
				label: `${seguimento.cgc} - ${seguimento.nome}`,
				value: [
					seguimento.codigo,
					seguimento.segmto,
					seguimento.cgc,
					seguimento.tabprc,
					seguimento.tpop,
					seguimento.tabesp,
				],
			}));

			return this.SelectEmpOpcao;
		} catch (error) {
			this.loginService.fazerLogout();
			return [];
		}
	}

	OpenVideo(video: string) {
		window.open(" https://youtu.be/" + video, "_blank");
	}

	async isOk(): Promise<boolean> {
		if (!this.EmpSegmento) {
			alert('Selecione uma empresa');
			return false;
		}

		this.isHideLoading = false;
		sessionStorage.setItem("Segmento", this.EmpSegmento[1]);
		sessionStorage.setItem("cgc", this.EmpSegmento[2].trim());

		try {
			const lojaRes = await firstValueFrom(this.homeService.getLoja(sessionStorage.getItem("cgc"), sessionStorage.getItem("Segmento")));
			if (lojaRes.length > 0) {
				const cli = lojaRes[0];
				sessionStorage.setItem("codcli", cli.codigo);
				sessionStorage.setItem("lojacli", cli.loja);
				sessionStorage.setItem("ufcli", cli.uf);
			}

			sessionStorage.setItem("tabprc", this.EmpSegmento[3]);
			sessionStorage.setItem("tpop", this.EmpSegmento[4]);
			sessionStorage.setItem("tabesp", this.EmpSegmento[5]);

			const params = this.homeService.getParams(this.EmpSegmento[1], '0301')
			const allParams = await firstValueFrom(params);

			const empresa = allParams.crm
			const condPg = allParams.pagto
			const cartao = allParams.cartao
			const pixCP = allParams.pix
			const vend1 = await firstValueFrom(this.homeService.getVend1(this.EmpSegmento[1]));

			sessionStorage.setItem("empresa", empresa.descricao);
			sessionStorage.setItem("vend1", vend1.CONTEUDO);
			sessionStorage.setItem("cpg", condPg.descricao);
			sessionStorage.setItem("cpcred", cartao.descricao);
			sessionStorage.setItem("cppix", pixCP.descricao);
		} catch (error) {
			console.error('Erro ao carregar dados:', error);
			this.isHideLoading = true;
			return false;
		}

		let emp = sessionStorage.getItem('empresa')
		if (emp) {
			this.isHideLoading = true;
			return true;
		} else {
			this.isHideLoading = true;
			this.poNotification.error("Problemas ao carregar os dados da empresa!")
			this.loginService.fazerLogout()
			return false;
		}
	}


}
